import { FieldError } from '@/components/common/FieldError';
import { RequiredAsterisk } from '@/components/common/RequiredAsterisk';
import { getFieldErrorId, getFieldHintId, getFieldLabelId } from '@/lib/formErrors';

export function FieldRow({ id, label, required = false, hint, error, children }) {
  return (
    <div className="space-y-2">
      <label id={getFieldLabelId(id)} htmlFor={id} className="block text-sm font-semibold text-graphite">
        {label}
        {required ? <RequiredAsterisk /> : null}
      </label>
      {children}
      {hint ? (
        <p id={getFieldHintId(id)} className="text-sm leading-relaxed text-steel">
          {hint}
        </p>
      ) : null}
      <FieldError id={getFieldErrorId(id)} message={error} />
    </div>
  );
}